// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3qaxv","errors":"Errors_errors__1kC6O"};